// Generated by purs version 0.15.16
import * as $foreign from "./foreign.js";
var observe = function () {
    return $foreign["_observe"];
};
export {
    mutationObserver,
    disconnect,
    takeRecords
} from "./foreign.js";
export {
    observe
};
//# sourceMappingURL=index.js.map
